import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'circular' | 'rectangular';
  sx?: Record<string, unknown>;
}

export const Skeleton = ({
  width = '100%',
  height = '20px',
  variant = 'text',
  sx = {}
}: SkeletonProps) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'circular':
        return {
          borderRadius: '50%',
          width: width,
          height: width, // Circular should have equal width and height
        };
      case 'rectangular':
        return {
          borderRadius: '4px',
          width: width,
          height: height,
        };
      case 'text':
      default:
        return {
          borderRadius: '4px',
          width: width,
          height: height,
        };
    }
  };

  return (
    <Box
      sx={{
        ...getVariantStyles(),
        background: 'linear-gradient(to right, #f0f0f0 8%, #e0e0e0 18%, #f0f0f0 33%)',
        backgroundSize: '800px 104px',
        animation: `${shimmer} 1.5s ease-in-out infinite`,
        ...sx,
      }}
    />
  );
};